interface Props {
  userScore: number;
  challengeLink: string;
}
export const shareOptions = ({ userScore, challengeLink }: Props) => [
  {
    name: "WhatsApp",
    icon: "💬",
    action: () =>
      window.open(
        `https://wa.me/?text=${encodeURIComponent(
          `🧠 Can you beat my score of ${userScore} in Probabl? I challenge you to outsmart cognitive biases! ${challengeLink}`
        )}`
      ),
  },
  {
    name: "Twitter/X",
    icon: "🐦",
    action: () =>
      window.open(
        `https://twitter.com/intent/tweet?text=${encodeURIComponent(
          `Just scored ${userScore} on @Probabl! 🧠 Can you beat my behavioral economics knowledge? Challenge: ${challengeLink}`
        )}`
      ),
  },
  {
    name: "LinkedIn",
    icon: "💼",
    action: () =>
      window.open(
        `https://www.linkedin.com/sharing/share-offsite/?url=${encodeURIComponent(
          challengeLink
        )}`
      ),
  },
  {
    name: "TikTok",
    icon: "🎵",
    action: () =>
      alert(
        "Record your reaction to the challenges and tag #ProbablChallenge!"
      ),
  },
];
